module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_pin-cc5532530154b162e873b03b3dee5ac5.svg";